import React, { createContext, useContext, useEffect, useState } from 'react';
import { DDD, E2Data } from '../lib/ddd/ddd';
import { OrgIdContext } from './orgId_context';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import useInterval from '../lib/useInterval';

export const WebsocketContext = createContext();
const wsUrl = (process.env.REACT_APP_WS_ORIGIN || "wss://"+window.location.host) + "/main.ws";
const url = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ping = new Uint8Array([0x09]);
let dt = new Date();
let _id = dt.getMilliseconds() + (1000 * dt.getSeconds()) + (60000 * dt.getMinutes()) + (3600000 * dt.getHours());

export const WebsocketProvider = ({ children }) => {
    /* const { sendMessage, lastMessage, readyState } = useWebSocket(wsUrl, {shouldReconnect: (closeEvent) => {console.log(closeEvent); return true}});

    useEffect(() => {
        console.log(ReadyState);
        console.log("Ready state: ", readyState);
         if (readyState === ReadyState.OPEN) {
            onOpen();
        } 
    }, [readyState]);

    useInterval(() => {
        if(sendMessage)
            sendMessage(ping);
    }, 50000);
    
    useEffect(() => {
        //console.log(lastMessage);
    }, [lastMessage]);

    const onOpen = () => {
        let send = {
            id: _id++,
            event: "entity",
            "one-time-only": false,
            constraints: {
                entity: "ddd/EU_Invoices",
                operation: "create",
                //"schema-filter": ["Name", "Content", "LogoUrl"],
                //"row-filter": "",
                "data-filter" : "1=1"
            }
        }
        sendMessage(JSON.stringify(send));
    }

    window.sendWS = () =>{
        const ddd = DDD.WithCustomRpcClient(url);
        //this._rpcClient.config.headers = {};
        ddd.getRpcClient().config.jsonRpcPreemptAfter = 0;
        ddd.getRpcClient().config.autoQueryPreempted = false;
        ddd.GetSessionAuthDescribe().then(res => {
            console.log(res);
            let wsobj = {};
            wsobj.id = res.id;
            wsobj.pid = res.error.data;
            wsobj.claim = true;
            sendMessage(JSON.stringify(wsobj));
        });
    } */

    return <WebsocketContext.Provider value={{}}>
        {children}
    </WebsocketContext.Provider>;
};